module.exports = __webpack_public_path__ + "static/media/grey-bg.f9ca19a1.jpg";